import { render, staticRenderFns } from "./StaticRootList.vue?vue&type=template&id=61167f1b&scoped=true&"
import script from "./StaticRootList.vue?vue&type=script&lang=js&"
export * from "./StaticRootList.vue?vue&type=script&lang=js&"
import style0 from "./StaticRootList.vue?vue&type=style&index=0&id=61167f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61167f1b",
  null
  
)

export default component.exports